import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

import { TemplateName } from '@/helpers/templateType';
import StudentModeHelper from '@/helpers/studentMode';

export default {
  computed: {
    ...mapGetters({
      getterCourse  : 'plataforma/newContent/getterCourse',
      getterContent : 'plataforma/newContent/getterContent'
    }),
    ...mapState({
      isStudentMode : (state) => state.plataforma.user.isStudentMode,
      userId        : state => state._core.user.id,
      username      : state => state._core.user.username,
      userRole      : state => state._core.auth.currentRole.role.alias
    }),
    templateName() {
      return this.$route.params.id ? this.getterContent.context?.templateName : this.getterCourse.context?.templateName;
    }
  },
  mounted() {
    const studentModeData = StudentModeHelper.getStudentModeCurrentSessionData(this.userId);
    if (!studentModeData) {
      this.setStudentMode(false);
      return;
    }
    if (studentModeData && !this.isStudentMode) {
      this.setStudentMode(true);
    }

    const allowedUrls = [
      `/course/${studentModeData.academicMainId}`,
      `/my-grades/${studentModeData.academicMainId}`,
      '/lti-launch'
    ];
    const isAccessingUnauthorizedUrls = !allowedUrls.some(element => this.$route.fullPath.includes(element));

    if (isAccessingUnauthorizedUrls) {
      this.setStudentMode(false);
      setTimeout(() => {
        this.$dialog.show({
          type                 : 'info',
          title                : this.$t(`course.studentMode.logout.leavingCourseModal.title.${studentModeData.academicMainType}`),
          message              : this.$t(`course.studentMode.logout.leavingCourseModal.message.${studentModeData.academicMainType}`),
          dark                 : this.templateName === TemplateName.STREAMING,
          showCancelButton     : false,
          confirmButtonText    : this.$t('common.okGotIt'),
          confirmButtonVariant : 'text',
          onConfirm            : () => {
            this.restoreOriginUserSession();
          },
          onClose: () => {
            this.restoreOriginUserSession();
          }
        });
      });
    }

    if (this.$route.fullPath.includes('/lti-launch/?type=lti') && this.$route.fullPath.includes('hideStudentModeFooter=true')) {
      this.setStudentMode(false);
    }
  },
  beforeMount() {
    this.$store.subscribeAction({
      after: (action) => {
        if (action.type === 'plataforma/courses/actionAccessStudentMode') {
          window.location.href = `${process.env.APPLICATION_ROUTE_BASE}/course/${action.payload.academicMainId}`;
        }

        if (action.type === 'plataforma/courses/actionLogoutStudentMode') {
          this.restoreOriginUserSession();
        }
      }
    });
  },
  methods: {
    ...mapActions({
      actionLogoutStudentMode: 'plataforma/courses/actionLogoutStudentMode'
    }),
    ...mapMutations({
      setStudentMode: 'plataforma/user/SET_USER_STUDENT_MODE'
    }),
    restoreOriginUserSession() {
      const studentModeData = StudentModeHelper.getStudentModeCurrentSessionData(this.userId);
      this.$token.set(studentModeData.originUser.token);

      this.$nextTick(() => {
        window.location.href = `${process.env.APPLICATION_ROUTE_BASE}${studentModeData ? studentModeData.originPath : '/' }`;
      });
    },
    handleLogout() {
      this.$dialog.show({
        type    : 'warning',
        title   : this.$t('course.studentMode.logout.modalTitle'),
        message : this.$t('course.studentMode.logout.modalMessage'),
        dark    : this.templateName === TemplateName.STREAMING,
        buttons : [
          {
            variant : 'text',
            text    : this.$t('common.cancel'),
            icon    : null,
            color   : null,
            action  : () => {
              this.$dialog.hide();
            }
          },
          {
            text   : this.$t('common.delete'),
            icon   : null,
            color  : 'error',
            action : async () => {
              this.$toast.show(this.$t('course.studentMode.logout.deleteUserInformationToast'));
              this.$dialog.hide();
              await this.logout();
            }
          },
          {
            variant     : 'default',
            text        : this.$t('course.studentMode.logout.keepDataBtnText'),
            icon        : null,
            color       : null,
            useLoading  : true,
            useDisabled : true,
            action      : async () => {
              this.$dialog.hide();
              this.$toast.success(this.$t('course.studentMode.logout.keepUserInformationToast'));
              this.$nuxt.$loading.start();
              this.restoreOriginUserSession();
            }
          }
        ]
      });
    },
    async logout() {
      this.$nuxt.$loading.start();

      try {
        const studentModeData = StudentModeHelper.getStudentModeCurrentSessionData(this.userId);

        await this.actionLogoutStudentMode(studentModeData.academicMainId);
      } catch (error) {
        this.$toast.error(error);
      } finally {
        this.$dialog.hide();
        this.$nuxt.$loading.finish();
      }
    }
  }
};
